/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClassValue } from './ClassValue';
import {
    ClassValueFromJSON,
    ClassValueFromJSONTyped,
    ClassValueToJSON,
} from './ClassValue';

/**
 * An element of a synopsis
 * @export
 * @interface Category3
 */
export interface Category3 {
    /**
     * The name of the category
     * @type {string}
     * @memberof Category3
     */
    name: string;
    /**
     * The percentage of calls which belong to this category
     * @type {number}
     * @memberof Category3
     */
    percentage: number;
    /**
     * The number of contacts in this category
     * @type {number}
     * @memberof Category3
     */
    numcontacts: number;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category3
     */
    customerSentiments?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category3
     */
    agentSentiments?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category3
     */
    resolutionRate?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category3
     */
    repeatCalls?: Array<ClassValue>;
}


/**
 * Check if a given object implements the Category3 interface.
 */
export function instanceOfCategory3(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "percentage" in value;
    isInstance = isInstance && "numcontacts" in value;

    return isInstance;
}

export function Category3FromJSON(json: any): Category3 {
    return Category3FromJSONTyped(json, false);
}

export function Category3FromJSONTyped(json: any, ignoreDiscriminator: boolean): Category3 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'percentage': json['percentage'],
        'numcontacts': json['numcontacts'],
        'customerSentiments': !exists(json, 'customerSentiments') ? undefined : ((json['customerSentiments'] as Array<any>).map(ClassValueFromJSON)),
        'agentSentiments': !exists(json, 'agentSentiments') ? undefined : ((json['agentSentiments'] as Array<any>).map(ClassValueFromJSON)),
        'resolutionRate': !exists(json, 'resolutionRate') ? undefined : ((json['resolutionRate'] as Array<any>).map(ClassValueFromJSON)),
        'repeatCalls': !exists(json, 'repeatCalls') ? undefined : ((json['repeatCalls'] as Array<any>).map(ClassValueFromJSON)),
    };
}

export function Category3ToJSON(value?: Category3 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'percentage': value.percentage,
        'numcontacts': value.numcontacts,
        'customerSentiments': value.customerSentiments === undefined ? undefined : ((value.customerSentiments as Array<any>).map(ClassValueToJSON)),
        'agentSentiments': value.agentSentiments === undefined ? undefined : ((value.agentSentiments as Array<any>).map(ClassValueToJSON)),
        'resolutionRate': value.resolutionRate === undefined ? undefined : ((value.resolutionRate as Array<any>).map(ClassValueToJSON)),
        'repeatCalls': value.repeatCalls === undefined ? undefined : ((value.repeatCalls as Array<any>).map(ClassValueToJSON)),
    };
}

